import { render, staticRenderFns } from "./NanHaiOverview.vue?vue&type=template&id=cb422b64&scoped=true&"
import script from "./NanHaiOverview.vue?vue&type=script&lang=js&"
export * from "./NanHaiOverview.vue?vue&type=script&lang=js&"
import style0 from "./NanHaiOverview.vue?vue&type=style&index=0&id=cb422b64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb422b64",
  null
  
)

export default component.exports